// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".year-container[data-v-5aa07f4a]{width:50vw}.error-msg[data-v-5aa07f4a]{color:red;border:1px solid red;background:#ffc6c6}.reveg-pct-input[data-v-5aa07f4a]{font-size:1.5em}.reveg-pct-input * .emphasised-input[data-v-5aa07f4a]{width:3em}.emphasised-input[data-v-5aa07f4a]{border:3px solid green;border-radius:5px;padding:.25em;background-color:#eaf0ea}", ""]);
// Exports
module.exports = exports;
